import React, { useEffect, useState } from "react";
import Loader from "../loader";
import PropTypes from "prop-types";
import LinkActionCard from "../cards/action-card/link-action-card";
import { getDataFromCmsApi } from "../../api/contentful-service";
import { getColorByIndex, isExternalLink } from "../../utils/utils";
import { Typography } from "@mui/material";

function DivisionServicesSmall({ collectionName, includeShortDescription = false }) {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getData().then(() => setIsLoading(false));
  }, []);

  const getData = async () => {
    const result = await getDataFromCmsApi(`Collection/${collectionName}`);
    setServices(result);
  };

  return isLoading ? (
    <Loader />
  ) : (
    <div className="py-5">
      <Typography variant="h2" className="text-center">
        Our Services
      </Typography>

      {services && services.items && services.items.length > 0 && (
        <>
          {!services.items[0].items ? (
            // If services.items is a list of single items
            <div className="grid-container grid-style-4 py-5">
              {services.items.map((item, i) => (
                <LinkActionCard
                  key={i}
                  title={item.serviceLabel}
                  linkDestination={item.link || ""}
                  cardColor={getColorByIndex(i)}
                  target={isExternalLink(item.link) ? "_blank" : ""}
                  shortDescription={includeShortDescription ? item.shortDescription : ""}
                />
              ))}
            </div>
          ) : (
            // if services.items is a list of lists
            services.items.map((item, index) => (
              <div key={index} className="py-5">
                {item.displayName && (
                  <>
                    <p
                      className="fw-bold text-center text-lg-start pb-4 pb-md-0"
                      style={{
                        color: "#626468",
                        fontSize: "1.6rem",
                        marginBottom: "-10px"
                      }}
                    >
                      {item.displayName}
                    </p>
                    <hr className="d-none d-md-block" />
                  </>
                )}

                <div key={index} className="grid-container grid-style-4 pt-1">
                  {item.items &&
                    item.items.length > 0 &&
                    item.items.map((subItem, i) => (
                      <LinkActionCard
                        key={i}
                        title={subItem.serviceLabel}
                        linkDestination={subItem.link || ""}
                        cardColor={getColorByIndex(index + i * 2)}
                        target={isExternalLink(subItem.link) ? "_blank" : ""}
                        shortDescription={includeShortDescription ? subItem.shortDescription : ""}
                      />
                    ))}
                </div>
              </div>
            ))
          )}
        </>
      )}
    </div>
  );
}

DivisionServicesSmall.propTypes = {
  collectionName: PropTypes.string.isRequired,
  includeShortDescription: PropTypes.bool
};

export default DivisionServicesSmall;
